document.querySelectorAll('.hps-root').forEach(function (root) {
  const track = root.querySelector('.hps-track');
  const slides = Array.from(root.querySelectorAll('.hps-slide'));
  if (slides.length < 2) return;

  const prevBtn = root.querySelector('.hps-prev');
  const nextBtn = root.querySelector('.hps-next');
  const counterCurrent = root.querySelector('.hps-counter-current');
  const autoplay = root.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let current = 0;
  let timer = null;

  if (prefersReducedMotion) {
    track.style.transition = 'none';
  }

  function showSlide(index) {
    slides[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    track.style.transform = 'translateX(-' + current * 100 + '%)';
    if (counterCurrent) counterCurrent.textContent = current + 1;
  }

  function next() {
    showSlide(current + 1);
  }

  function prev() {
    showSlide(current - 1);
  }

  function startAutoplay() {
    if (!autoplay || prefersReducedMotion) return;
    stopAutoplay();
    timer = setInterval(next, autoplaySpeed);
  }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      next();
      startAutoplay();
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      prev();
      startAutoplay();
    });
  }

  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);

  startAutoplay();
});
